import styled from 'styled-components/macro';

export const $Option = styled.div`
  display: flex;
  align-items: center;
  height: ${({ optionHeight }) => optionHeight && `${optionHeight}px`};
  padding-left: 4px;
`;
